import PropTypes from 'prop-types'
import Slot from 'model/appointments/timeSlots/slot'
import { isNil } from 'ramda'
import dayjs from 'dayjs'

class Time extends Slot {
  constructor(init) {
    super(init)
    // console.log('> Time constructor -', init)
    if (isNil(init)) return undefined
    this._date = init.date
    this._start = init.start
    this._start_time = init.start_time
    this._end = init.end
    this._end_time = init.end_time
  }

  static shape = {
    id: PropTypes.string.isRequired,
    date: PropTypes.string,
    start: PropTypes.number,
    start_time: PropTypes.string,
    end: PropTypes.number,
    end_time: PropTypes.string
  }

  get date() {
    return this._date
  }

  get start() {
    return this._start
  }

  get start_time() {
    return this._start_time
  }

  get end() {
    return this._end
  }

  get end_time() {
    return this._end_time
  }

  // Calcualble

  get weekDay() {
    return dayjs(this.date).format('dddd')
  }

  get monthDay() {
    return dayjs(this.date).format('M/DD')
  }

  get displayTime() {
    return `${dayjs(this.start_time, 'HH:mm:ss').format('LT')}`
  }

  get timeRange() {
    return `${dayjs(this.start_time, 'HH:mm:ss').format('LT')} - ${dayjs(
      this.end_time,
      'HH:mm:ss'
    ).format('LT')}`
  }

  get toObject() {
    return {
      ...super.toObject,
      date: this.date,
      start: this.start,
      end: this.end
    }
  }
}

export default Time
